import { useState } from 'react';
import { Workbox } from './Workbox';
import { EntityPluginDevxprotectExperienceCard } from '@devxprotect/plugin-devxprotect-experience';

const SummaryTable = () => {
  const [, setIsDataLoading] = useState(true);
  const [, setNumItems] = useState<number>(0);

  return (
    <Workbox
      consistentHeight
      color="blue"
      title="My Teams"
      component="teams"
      buttonTitle="View All"
      showButton
      navigatePath="/action-center/my-teams"
      info="This section is used to show SDL teams associated to the user and its maturity statuses.GREEN - satisfactory, YELLOW - needs attention, RED - critical to look at, GRAY - practice not started"
      subHeader="All your teams and their activity "
    >
      <EntityPluginDevxprotectExperienceCard
        setNumItems={setNumItems}
        setIsDataLoading={setIsDataLoading}
        expanded={false}
      />
    </Workbox>
  );
};

/**
 * A component that displays list of teams associated to a User.
 * @constructor
 */
export const MyTeams = () => {
  return <SummaryTable />;
};
